export const GET_PD = 'GET_PD';
export const GET_PD_SUCCESS = 'GET_PD_SUCCESS';
export const GET_PD_FAILURE = 'GET_PD_FAILURE';
export const SET_PD = 'SET_PD';
export const SET_PD_SUCCESS = 'SET_PD_SUCCESS';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_ERROR_SUCCESS = 'CLEAR_ERROR_SUCCESS';
